import {Component, OnInit} from '@angular/core';
import {AuthService} from '../../services/auth';
import {Router} from '@angular/router';
import {User} from '../../classes/user';
import {HttpErrorResponse} from "@angular/common/http";

@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent implements OnInit {
    signedIn: boolean = false;
    user: User = new User();

    constructor(private authService: AuthService,
                private router: Router) {
    }

    ngOnInit(): void {
        this.authService.getUser()
            .subscribe({
                next: (user: any) => {
                    this.user = user;
                    this.signedIn = true;
                },
                error: (err: HttpErrorResponse) => {
                    console.log(err);
                }
            });
    }

    signOut(e: any) {
        e.preventDefault();
        this.authService.signOut();
        this.router.navigate(['/login']);
    }
}
